export const Regime = {
  CNSS: 'CNSS',
  CNOPS: 'CNOPS',
  CIMR: 'CIMR',
  RAMED: 'RAMED'
};

export const getRegimeOptions = () => {
  return [
    { value: "", label: "Tous les régimes" },
    ...Object.entries(Regime).map(([key, label]) => ({
      value: key,   // 🔥 IMPORTANT
      label,
    })),
  ];
};